import { Box, FormLabel, Switch } from "@mui/material";
import { styled } from "@mui/styles";

const PurpleSwitch = styled(Switch)(() => ({
  "&.MuiSwitch-switchBase.Mui-checked": {
    color: "rgb(201, 126, 245)",
    "&:hover": {
      backgroundColor: "purple",
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "rgb(201, 126, 245)",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "rgb(201, 126, 245)",
  },
}));
type Props = {
  label?: string;
  value?: boolean;
  defaultValue?: boolean;
  onChange: (checked: boolean) => void;
};
export const SwitchButton = ({
  label,
  value,
  defaultValue,
  onChange,
}: Props) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      width="100%"
      padding="0 .5rem"
    >
      <FormLabel
        required
        sx={{
          width: "100%",
          textAlign: "right",
          color: "divider",
          fontSize: "1.2rem",
          fontFamily: "'YekanBold !important'",
          "& .MuiFormLabel-asterisk": { color: "red" },
        }}
      >
        {label}
      </FormLabel>
      <PurpleSwitch
        sx={{ color: "customColors.purple" }}
        defaultChecked={defaultValue}
        onChange={(_, ch) => onChange(ch)}
      />
    </Box>
  );
};
